module.exports = __webpack_public_path__ + "img/footer-1-1.e3a0e710.png";